<div class="ion-text-center">
    <ion-text>War Deine Bewältigungsstrategie <b>"{{text}}"</b> erfolgreich?</ion-text>
    <plugin-rating-bar [(rating)]="rating" [titles]="['Überhaupt nicht', 'Selten', 'Manchmal', 'Häufig', 'Überwiegend', 'Fast immer', 'Immer']" [readonly]="readOnly"></plugin-rating-bar>
</div>
